export default __webpack_public_path__ + "static/media/unfold_UF.a4c843c3.png";